import {
    isString,
    isNumber,
    isObject,
    round2
} from "./main";
import {
    timestamp2userdate,
    parseDate
} from "./date";
import {
    stripTags
} from "./dom";

// отгадай загадку, есть 3 сущности,
// которые работают со строками из базы
// null они должны преобразовать в пустую строка,
// комплексные поля объединить в {id: 1, value: ""}.
// где разместить функцию, которая преобразует строки?
// P.S. наследовать нельзя, т.к. сущности очень разные

// !! WARNING !!
// строка обрабатывается по ССЫЛКЕ
// используем deepClone перед processServerRow
export function processServerRow(row, fields) {
    if ( !row ) {
        return;
    }

    if ( row.COLORS == null ) {
        row.COLORS = { color: "transparent", fields: {} };
    }
    row._id = row.ID || row.id || row._id;

    if ( !row._original ) {
        row._original = {};
    }

    fields.forEach(function(field) {
        let key = field.key;


        let type = field.type;

        if ( row[key] == null ) {
            //console.log('processServerRow %s is null', key);
            if ( type !== "currency" ) {
                row[key] = "";
            }
        } else {
            row[key] += "";
            row._original[key] = row[key];
        }

        if ( field.isComplex && !row[key] ) {
            let complex = {};


            let complexKey;

            for (let name in row) {
                if ( name.indexOf(key) === 0 && name.indexOf(".") != -1 ) {
                    complexKey = name.split(".")[1];
                    complex[complexKey] = row[name];
                    delete row[name];
                }
            }

            row[key] = complex;
            row._original[key] = complex;
        }

        if ( type == "html" ) {
            row._original[key] = row[key];
            row[key] = stripTags(row[key]);
        }

        // {id: 1, value: "Рубли"} -> Рубли
        if ( isObject(row[key]) ) {
            if ( row[key].value == null ) {
                row[key] = "";
            } else {
                row[key] = row[key].value;
            }
        }

        if ( type == "date" || key == "DT_CREATE" ) {
            row._original[key] = +row[key];
            if ( !row[key] ) {
                row[key] = "";
            } else {
                row[key] = timestamp2userdate(parseDate(row[key]).date).split(" ")[0];
            }
        }

        if ( type == "datetime" ) {
            row._original[key] = row[key];
            if ( !row[key] ) {
                row[key] = "";
            } else {
                row[key] = timestamp2userdate(parseDate(row[key]).date);
            }
        }

        if ( type == "currency" || key == "REMAINS" || key == "REMAINS_RUR" ) {
            //console.log('processServer row', type, key, row[key]);
            row._original[key] = row[key];
            if ( row[key] !== null || key == "REMAINS" || key == "REMAINS_RUR" || key == "REMAINS_RUR_400" ) {
                row[key] = Math.round(Math.round (row[key]) / 10000); // TAG: currency10000
            }
            row[key] = currencySpaces(row[key]);
        }
    });

    return row;
}

export function currencySpaces(rawValue, options) {
    if ( rawValue === null ) {
        return "";
    }

    const { float: floatOption, withoutSpaces } = options || {};

    let parsedValue = rawValue ? currencyToNumber(rawValue) : "";

    if ( !floatOption && floatOption !== 0 ) {
        parsedValue = round2(parsedValue, 2);
    }

    let [
        integerPart = "",
        decimalPart = ""
    ] = `${parsedValue}`.split(".");

    const integerPartCheckSpaces = withoutSpaces
        ? integerPart
        : getIntegerPartWithSpaces(integerPart);

    const preciseDecimalPart = getPreciseDecimalPart(
        integerPart,
        decimalPart,
        floatOption
    );

    if ( preciseDecimalPart.length === 0 ) {
        return integerPartCheckSpaces;
    }

    return `${integerPartCheckSpaces}.${preciseDecimalPart}`;
}

function getIntegerPartWithSpaces(integerPart, charsBetweenSpaces = 3) {
    if ( !Number.isInteger(+integerPart) ) {
        return integerPart;
    }

    const integerPartString = `${integerPart}`.trim().replace(".", "");

    const firstChar = integerPartString.slice(0, 1);
    const minus = firstChar === "-" ? firstChar : "";

    let integerPartWithoutMinus = minus
        ? integerPartString.slice(1)
        : integerPartString;

    const spacesCount = integerPartWithoutMinus.length % charsBetweenSpaces === 0
        ? integerPartWithoutMinus.length / charsBetweenSpaces - 1
        : Math.floor(integerPartWithoutMinus.length / charsBetweenSpaces);

    for (let i = 0; i < spacesCount; i++) {
        // индекс отрицательный, потому что считается с конца строки
        const spaceIndex = -(charsBetweenSpaces + i * charsBetweenSpaces + i);

        integerPartWithoutMinus = integerPartWithoutMinus.slice(0, spaceIndex)
            + " "
            + integerPartWithoutMinus.slice(spaceIndex);
    }

    return `${minus}${integerPartWithoutMinus}`;
}

function getPreciseDecimalPart(integerPart, decimalPart, floatOption) {
    if ( floatOption === "auto" ) {
        return decimalPart;
    }

    if ( isNumber(floatOption) ) {
        decimalPart = decimalPart.slice(0, floatOption);

        const missingZerosCount = floatOption - decimalPart.length;
        for (let i = 0; i < missingZerosCount; i++) {
            decimalPart += "0";
        }

        return decimalPart;
    }

    if ( decimalPart.length === 1 ) {
        return decimalPart + "0";
    }

    if ( decimalPart.length === 0 && integerPart.length > 0 ) {
        return "00";
    }

    return decimalPart;
}

export function currencyToNumber(currency) {
    if ( isString(currency) ) {
        const sanitizedCurrency = currency
            .replace(/ /g, "")
            .replace(/,/g, ".");

        return parseFloat(sanitizedCurrency) || 0;
    }
    else if ( isNumber(currency) ) {
        return currency;
    } else {
        return 0;
    }
}
